// Polyfill for 'new Event'
(function (w) {
  if (typeof w.Event === "function") return false;

  function Event(event, params) {
    params = params || { bubbles: false, cancelable: false, detail: null };
    var evt = document.createEvent('Event');
    evt.initEvent(event, params.bubbles, params.cancelable, params.detail);
    return evt;
  }

  Event.prototype = w.Event.prototype;

  w.Event = Event;
})(window);
